import environment from '../config/environment';
import { UrlSubTree, UrlTree } from '../types/url';
import { v4 as uuid } from 'uuid';

export const rentalUrls = {
  id: uuid(),
  path: 'rent',
  subPath: {
    cart: { id: uuid(), path: 'cart' },
    categories: { id: uuid(), path: 'categories' },
    checkout: { id: uuid(), path: 'checkout' },
    orderDetails: { id: uuid(), path: 'order-details' },
  },
} satisfies UrlSubTree;

export const signUpUrls = {
  id: uuid(),
  path: 'signup',
  subPath: {
    verifyEmail: { id: uuid(), path: 'verify-email' },
    confirmation: { id: uuid(), path: 'confirmation' },
    createAccount: { id: uuid(), path: 'create-account' },
    inviteTeam: { id: uuid(), path: 'invite-team' },
  },
} satisfies UrlSubTree;

export const estrackUrls = {
  id: uuid(),
  subPath: {
    dashboard: { id: uuid(), type: 'external', path: environment.FLEET_APP_URL },
    t3Fleet: { id: uuid(), type: 'external', path: `${environment.FLEET_APP_URL}/#/assets/all` },
    billing: { id: uuid(), type: 'external', path: `${environment.FLEET_APP_URL}/#/billing` },
    help: { id: uuid(), type: 'external', path: 'https://help.estrack.com/en/' },
  },
} satisfies UrlSubTree;

export const externalUrls = {
  id: uuid(),
  subPath: {
    applyForCreditAccount: {
      id: uuid(),
      type: 'external',
      path: 'https://equipmentshare.jotform.com/251044714690050',
    },
    analytics: {
      id: uuid(),
      type: 'external',
      path: 'https://analytics.estrack.com/dashboard/rental-management-dashboard-12',
    },
  },
} satisfies UrlSubTree;

export const accountUrls = {
  id: uuid(),
  path: 'account',
  subPath: {
    profile: {
      id: uuid(),
      path: 'profile',
      subPath: {
        billing: {
          id: uuid(),
          path: 'billing',
        },
        company: {
          id: uuid(),
          path: 'company',
        },
        jobsiteInfo: {
          id: uuid(),
          path: 'jobsites',
          subPath: {
            jobsiteAdd: {
              id: uuid(),
              path: 'add',
            },
          },
        },
        manageTeam: {
          id: uuid(),
          path: 'team',
          subPath: {
            manageTeamAdd: {
              id: uuid(),
              path: 'invite',
            },
          },
        },
        notification: {
          id: uuid(),
          path: 'notification',
        },
        personal: {
          id: uuid(),
          path: 'personal',
        },
      },
    },
    orders: {
      id: uuid(),
      path: 'orders',
      subPath: {
        order: { id: uuid(), path: 'order-list' },
      },
    },
    rentals: {
      id: uuid(),
      path: 'rentals',
      subPath: {
        active: { id: uuid(), path: 'active-list' },
      },
    },
    invoices: {
      id: uuid(),
      path: 'invoices',
      type: 'external',
      externalLink: estrackUrls.subPath.billing.path,
    },
    rentalInsurance: { id: uuid(), path: 'rental-insurance' },
    rentalAgreements: { id: uuid(), path: 'rental-agreements' },
    reportingCompanies: { id: uuid(), path: 'reporting/companies' },
    reportingEmissions: { id: uuid(), path: 'reporting/emissions' },
    cameras: { id: uuid(), path: 'cameras' },
    reporting: { id: uuid(), path: 'reporting' },
    p66: { id: uuid(), path: 'p66-request' },
  },
} satisfies UrlSubTree;

export const authUrls = {
  id: uuid(),
  subPath: {
    login: {
      id: uuid(),
      path: 'login',
      subPath: {
        callback: { id: uuid(), path: 'callback' },
      },
    },
  },
} satisfies UrlSubTree;

export const url = {
  account: accountUrls,
  estrack: estrackUrls,
  rental: rentalUrls,
  signup: signUpUrls,
  auth: authUrls,
  externalUrls: externalUrls,
  notifications: { id: uuid(), path: '' },
} satisfies UrlTree;
